(() => {
  const summarySelector = '[data-hc="product-summary"]';
  const cardRatingSelector = '.hc-widget--card-rating [data-hc="product-rating"]';

  function updateSummary(summary) {
    const stars = summary.querySelectorAll('.hc-product-summary__rating .hc-icon');
    if (!stars.length) return;

    const hasRating = Array.from(stars).some((star) => star.classList.contains('hc-icon--star'));
    summary.classList.toggle('hc-product-summary--unrated', !hasRating);
  }

  function updateAllSummaries() {
    document.querySelectorAll(summarySelector).forEach(updateSummary);
    document.querySelectorAll(cardRatingSelector).forEach(updateCardRating);
  }

  function updateCardRating(mount) {
    const widget = mount.closest('.hc-widget--card-rating');
    const rating = mount.querySelector('.hc-product-rating');
    const reviewCount = rating?.querySelector('.hc-product-rating__review-count')?.textContent.match(/\d+/)?.[0];
    const fullStars = rating?.querySelectorAll('.hc-icon--star').length || 0;
    const halfStars = rating?.querySelectorAll('.hc-icon--star-half').length || 0;
    const hasRating = fullStars > 0 && reviewCount;

    widget?.classList.toggle('hc-widget--card-rating-ready', Boolean(hasRating));
    if (!hasRating || !widget) return;

    const ratingValue = (fullStars + halfStars * 0.5).toFixed(1);
    widget.dataset.rating = ratingValue;
    widget.dataset.reviewCount = reviewCount;
    rating.dataset.rating = ratingValue;
    widget.setAttribute('aria-label', `Rating ${ratingValue} din 5, din ${reviewCount} recenzii`);
  }

  function start() {
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        updateAllSummaries();
      });
    });

    updateAllSummaries();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
